export const initBeforeCrud = () => {
    let _beforeCrud = ({ content }) => Promise.resolve({
        type: 'OK',
        content,
    });
    return {
        onBeforeCrud: (beforeCrud) => {
            _beforeCrud = beforeCrud;
        },
        executeBeforeCrud: (...args) => _beforeCrud(...args),
    };
};
//# sourceMappingURL=comments-before-crud-interceptor.js.map